import axios from "axios";
import { HubConnectionBuilder } from "@microsoft/signalr";
// Función encargada de calcular el coste por cantidad exacta. El elemento payload debe conteer el campo listReprocesos
export const CalcularPrecioCantidadesExactas = ({ payload, divisa, isProveedor, language, key }) => {
    return axios.post(`${process.env.VUE_APP_API_REPROCESOS}/Reprocesos/CalcularCantidadesExactas`, payload, {
        params: {
            divisa,
            isProveedor,
            language
        },
        headers: {
            "Content-Type": "text/json",
            ReprocesosKey: key
        },
    })
};


// Función para carlcular una técnica cualquiera
export const CalcularTecnica = ({ payload, key }) => {
    return axios
        .get(`${process.env.VUE_APP_API_REPROCESOS}/Reprocesos/CalcularPrecios`, {
            params: payload,
            headers: {
                ReprocesosKey: key
            }
        });
};

// Función para recuperar toda la información de un modelo
export const FetchModelo = ({ modelCode, reprocesosKey, language, isYouReprocesos, cancelToken }) => {
    if (!modelCode || !reprocesosKey) return Promise.reject(new Error(`Missing parameters in FetchModelo function`));

    if (!language) language = "es-ES";

    let headers = {};

    headers = {
        ...headers,
        ReprocesosKey: reprocesosKey
    }

    const config = {
        params: {
            modelCode,
            isFromYouReprocesos: isYouReprocesos,
            language
        },
        headers
    };

    if (cancelToken) {
        config.cancelToken = cancelToken?.token ?? cancelToken;
    }

    return axios.get(`${process.env.VUE_APP_API_REPROCESOS}/Info/Modelo/${modelCode}`, config);
}

// Función para recuperar el catalogo completo de Azure
export const FetchCatalog = () => {
    const blob = process.env.VUE_APP_BLOB_URL;
    return axios
        .get(`${process.env.VUE_APP_STATIC_IMG_URL}/${blob}/Catalog/catalog_info.json`)
}

// Función para recuperar el fondo de los distintos colores
export const FetchFondoColor = () => {
    return axios.get(`${process.env.VUE_APP_API_REPROCESOS}/Info/Colors`)
}

// Función para obtener las manipulaciones del modelo actual
export const FetchManipulados = ({ modelCode, language }) => {
    if (!modelCode) return Promise.reject(new Error(`Missing parameters in FetchManipulados function`));

    if (!language) language = "es-ES";

    return axios.get(`${process.env.VUE_APP_API_REPROCESOS}/Info/Modelo/${modelCode}/Manipulados`, {
        params: {
            language
        }
    })
}

// Función para obtener los tamaños para sublimación dado un modelo
export const FetchSublimacionSizes = ({ modelCode }) => {
    if (!modelCode) return Promise.reject(new Error(`Missing parameters in FetchSublimacionSizes function`));

    return axios.get(`${process.env.VUE_APP_API_REPROCESOS}/Info/Sublimacion/Size`,
        {
            params: {
                modelCode
            }
        })
}

// Función para obtener los tamaños para números DTF
export const FetchDtfNumerosSizes = () => {
    return axios.get(`${process.env.VUE_APP_API_REPROCESOS}/Info/DtfNumeros/Size`)
}

// Función para obtener el tamaño para numeros transfer
export const FetchTransferNumerosSizes = () => {
    return axios
        .get(
            `${process.env.VUE_APP_API_REPROCESOS}/Info/TransferNumeros/Size`
        );
}

// Función para obtener los tamaños de digital
export const FetchSizeDigitalOptions = ({ isTextil, modelCode, reprocesosKey, posicion }) => {

    if (isTextil) {
        return FetchSizeDigitalTextilOptions({ modelCode, reprocesosKey, posicion });
    }

    return axios
        .get(
            `${process.env.VUE_APP_API_REPROCESOS}/Reprocesos/Tamanos/Digital?modelCode=${modelCode}&posicion=${posicion}`,
            {
                headers: {
                    ReprocesosKey: reprocesosKey
                },
            }
        )
}

export const FetchSizeDigitalTextilOptions = ({ modelCode, reprocesosKey, posicion }) => {
    return axios
        .get(
            `${process.env.VUE_APP_API_REPROCESOS}/Info/DigitalTextil/Size?modelCode=${modelCode}&posicion=${posicion}`,
            {
                headers: {
                    ReprocesosKey: reprocesosKey
                },
            }
        )
}

export const SignalRConection = ({ reprocesosKey }) => {
    return new HubConnectionBuilder()
        .withUrl(`${process.env.VUE_APP_API_REPROCESOS}/hubs/parser`, {
            // SEGURIDAD: Aquí pasamos el token.
            // SignalR lo enviará como "Authorization: Bearer <TOKEN>"
            // O como query string "?access_token=<TOKEN>" si usa WebSockets (navegadores)
            accessTokenFactory: () => reprocesosKey
        })
        .withAutomaticReconnect([0, 2000, 5000])
        .build();
}

export const TurnPostscriptToPng = async ({ reprocesosKey, fileInfo, connectionId }) => {
    const headers = {
        ReprocesosKey: reprocesosKey,
        "X-SignalR-Connection-Id": connectionId
    }
    return axios.post(`${process.env.VUE_APP_API_REPROCESOS}/Parser/POSTSCRIPT`,
        fileInfo,
        {
            headers,
            responseType: 'blob'
        }
    ).then(response => {
        // TRANSFORMACIÓN A BASE64
        // Interceptamos la respuesta para devolver directamente la imagen lista para el <img src>
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result); // Devuelve "data:image/png;base64,..."
            reader.onerror = reject;
            reader.readAsDataURL(response.data); // response.data es el Blob
        });
    });
}

export const FetchNumColor = ({ reprocesosKey, fileInfo }) => {
    const headers = {
        ReprocesosKey: reprocesosKey
    }
    return axios.post(`${process.env.VUE_APP_API_REPROCESOS}/Parser/ColorCount`,
        fileInfo,
        {
            headers
        }
    );
}